import { defineStore } from 'pinia';

// Types
import type { UserData } from '@white-label-types/stores';

type VehicleLookUpState = { [key: string]: boolean };
export interface PaymentFormState {
  formData: null | UserData,
  timestamp: null | string,
  vehicleLookUp: null | VehicleLookUpState,
}

export type StoreFormDataPayload = {
  formData: UserData,
  timestamp?: string
}

/**
 * Payment form store definition
 *
 * @returns {StoreDefinition}
 */
export const usePaymentFormStore = defineStore({
  id: 'paymentForm',

  actions: {
    commitStoreFormData(payload: StoreFormDataPayload) {
      // @ts-expect-error - types are correct but package is out of date
      this.formData = { ...payload.formData };
      // @ts-expect-error - types are correct but package is out of date
      if (payload.timestamp) this.timestamp = payload.timestamp;
    },

    commitStoreVehicleLookUpState(payload: VehicleLookUpState) {
      // @ts-expect-error - types are correct but package is out of date
      this.vehicleLookUp = { ...payload };
    },

    commitClearFormData() {
      // @ts-expect-error - types are correct but package is out of date
      this.formData = null;
      // @ts-expect-error - types are correct but package is out of date
      this.timestamp = null;
      // @ts-expect-error - types are correct but package is out of date
      this.vehicleLookUp = null;
    },
  },

  getters: {
    readPaymentFormData: (state) => state.formData,
    readVehicleLookUpState: (state) => state.vehicleLookUp,
  },

  state() {
    return {
      formData: null,
      vehicleLookUp: null,
      timestamp: null,
    }
  },

  // @ts-expect-error - Persist plugin is not typed
  persist: {
    storage: process.client ? sessionStorage : undefined,
  },
});
